import type { PayloadAction } from '@reduxjs/toolkit';

import createTicketSlice, { initialState } from '@sv-support-sdk/store/src/modules/tickets/slices';
import { ITicket } from '@sv-support-sdk/shared-types/src/common/tickets';

const ticketsSlice = createTicketSlice({
  name: 'tickets',
  initialState,
  reducers: {
    updateTicketsList(state, action: PayloadAction<ITicket>) {
      state.list = state.list.map((ticket) => ({ ...ticket, ...action.payload }));
    },
  },
});

export const {
  setTickets,
  setTicketsMeta,
  setTicketsLoading,
  setSelectedTicketLoading,
  setSelectedTicket,
  updateSelectedTicket,
  setLoading,
  setReplyAttachments,
  deleteReplyAttachment,
  addMessageToSelectedTicket,
  clearReplyAttachments,
  resetState,
  addTicketToList,
  addMessageToTicketList,
  setUnreadTicketMessages,
  removeMessagesFromUnread,
  updateTicketsList,
} = ticketsSlice.actions;

export default ticketsSlice.reducer;
